// Enum for environment keys
export enum WebAppEnvironment {
  STAGING = 'staging',
  PRODUCTION = 'production',
  SAMWISE = 'samwise',
  FRODO = 'frodo',
  MERRY = 'merry',
  PIPPIN = 'pippin',
  BILBO = 'bilbo',
}

// Core pagination types
export type CursorPaginationParams = {
  paginationFirst?: number;
  paginationAfter?: string;
  paginationLast?: number;
  paginationBefore?: string;
};

export type SortingParams = {
  sortByField: string;
  sortByOrder: 'asc' | 'desc';
};

export type PagePaginationParams = {
  currentPage?: number;
  perPage?: number;
};

// Combined pagination type that can be used across the application
export type PaginationAndFiltersParams = CursorPaginationParams
  & SortingParams
  & PagePaginationParams & {
    filters?: {
      key: string;
      type: 'including' | 'excluding';
      value: string | boolean | number;
    }[];
    searchTerm?: string;
  };

export type PaginationResult<T> = {
  data: T[];
  totalCount: number;
  pageInfo: {
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor: string | null;
    endCursor: string | null;
    totalCount: number;
  };
} & PagePaginationParams;
